// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$String from "../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as RegexUtils$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/utils/RegexUtils.mjs";
import * as AuthConfig$PorterinFeature from "../../../login/domain/config/AuthConfig.mjs";
import * as LocalStorage$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/helpers/LocalStorage.mjs";
import * as CommonHelper$PorterinFeature from "../../../../shared/core/helpers/CommonHelper.mjs";
import * as ExtendedAddress$PorterinFeature from "../entity/ExtendedAddress.mjs";
import * as FareEstimateHelper$PorterinFeature from "../../../../shared/core/helpers/FareEstimateHelper.mjs";
import * as FareEstimateStoreV1$PorterinFeature from "../store/FareEstimateStoreV1.mjs";

function setBookingDetailsInStorage(data, waypoint) {
  localStorage.setItem(waypoint === /* Pickup */0 ? FareEstimateStoreV1$PorterinFeature.senderLocalStorageKey : FareEstimateStoreV1$PorterinFeature.receiverLocalStorageKey, Belt_Option.getWithDefault(JSON.stringify(data), ""));
}

function readBookingDetailsFromStorage(waypoint) {
  var value = LocalStorage$PorterinUtils.readPropertyFromLocalStorage(waypoint === /* Pickup */0 ? FareEstimateStoreV1$PorterinFeature.senderLocalStorageKey : FareEstimateStoreV1$PorterinFeature.receiverLocalStorageKey);
  if (value !== undefined) {
    return JSON.parse(value);
  }
  
}

function getBookingDetailsName(booking_details_storage, query_params, waypoint) {
  if (booking_details_storage !== undefined) {
    return booking_details_storage.name;
  } else if (waypoint) {
    return query_params.customer_name;
  } else {
    return query_params.sender_name;
  }
}

function getBookingDetailsMobile(booking_details_storage, query_params, waypoint) {
  if (booking_details_storage !== undefined) {
    return booking_details_storage.mobile;
  } else if (waypoint) {
    return query_params.customer_mobile;
  } else {
    return query_params.sender_mobile;
  }
}

function createBookingObject(query_params, waypoint) {
  var bookingDetailsFromStorage = readBookingDetailsFromStorage(waypoint);
  return {
          pickup_address: {
            landmark: FareEstimateHelper$PorterinFeature.getLandmarkLocation(query_params.from_address_landmark),
            location: {
              lat: FareEstimateHelper$PorterinFeature.getLocationCoordinates(query_params.from_address_lat),
              lng: FareEstimateHelper$PorterinFeature.getLocationCoordinates(query_params.from_address_long)
            },
            extended_address: ExtendedAddress$PorterinFeature.initial_extended_address(undefined)
          },
          drop_address: {
            landmark: FareEstimateHelper$PorterinFeature.getLandmarkLocation(query_params.to_address_landmark),
            location: {
              lat: FareEstimateHelper$PorterinFeature.getLocationCoordinates(query_params.to_address_lat),
              lng: FareEstimateHelper$PorterinFeature.getLocationCoordinates(query_params.to_address_long)
            },
            extended_address: ExtendedAddress$PorterinFeature.initial_extended_address(undefined)
          },
          name: getBookingDetailsName(bookingDetailsFromStorage, query_params, waypoint),
          number: getBookingDetailsMobile(bookingDetailsFromStorage, query_params, waypoint),
          house: Belt_Option.map(bookingDetailsFromStorage, (function (value) {
                  return value.house_address;
                }))
        };
}

function validateHouseAddress(address) {
  var name_regex = /[^a-zA-Z\s]+/;
  var match = address.length;
  if (match === 0) {
    return {
            TAG: /* Error */1,
            _0: FareEstimateStoreV1$PorterinFeature.form_apartment_name_error_msg
          };
  }
  if (!RegexUtils$PorterinUtils.hasAtleastOneAlphabet(address)) {
    return {
            TAG: /* Error */1,
            _0: FareEstimateStoreV1$PorterinFeature.form_apartment_name_error_msg
          };
  }
  var num = address.length;
  if (num > AuthConfig$PorterinFeature.max_name_char_length) {
    return {
            TAG: /* Error */1,
            _0: FareEstimateStoreV1$PorterinFeature.form_apartment_name_max_char_error_msg
          };
  } else if (num < AuthConfig$PorterinFeature.min_name_char_length) {
    return {
            TAG: /* Error */1,
            _0: FareEstimateStoreV1$PorterinFeature.form_apartment_name_error_msg
          };
  } else if (name_regex.test(address)) {
    return {
            TAG: /* Error */1,
            _0: FareEstimateStoreV1$PorterinFeature.form_special_characters
          };
  } else {
    return {
            TAG: /* Ok */0,
            _0: address
          };
  }
}

function orderReviewLinkCreator(sender, receiver, vehicle_id, user) {
  var userMobile = user !== undefined ? Belt_Option.getWithDefault(user.mobile, "") : "";
  var senderMobile = Belt_Option.getWithDefault(sender.number, userMobile);
  return "/order-review?sender_mobile=" + senderMobile + "&sender_name=" + Belt_Option.getWithDefault(sender.name, "Sender") + "&receiver_mobile=" + Belt_Option.getWithDefault(receiver.number, "") + "&receiver_name=" + Belt_Option.getWithDefault(receiver.name, "Receiver") + "&from_landmark=" + sender.pickup_address.landmark + "&from_lat=" + String(sender.pickup_address.location.lat) + "&from_long=" + String(sender.pickup_address.location.lng) + "&from_house=" + Belt_Option.getWithDefault(sender.house, "") + "&to_landmark=" + receiver.drop_address.landmark + "&to_lat=" + String(receiver.drop_address.location.lat) + "&to_long=" + String(receiver.drop_address.location.lng) + "&to_house=" + Belt_Option.getWithDefault(receiver.house, "") + "&vehicle_id=" + String(vehicle_id) + "";
}

function validateAddressWithoutBounds(address) {
  if ($$String.trim(address.landmark).length !== 0 && CommonHelper$PorterinFeature.hasAtleastOneAlphabet(address.landmark)) {
    if (address.location.lat > 0.0 && address.location.lat < 1000.0) {
      return {
              TAG: /* Ok */0,
              _0: address
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: "No result found"
            };
    }
  } else {
    return {
            TAG: /* Error */1,
            _0: "Please enter the valid address"
          };
  }
}

function getSpotServiceCategory(service_category) {
  switch (service_category) {
    case "compact" :
        return /* Compact */5;
    case "partload" :
        return /* Partload */8;
    case "trucks" :
        return /* Trucks */4;
    default:
      return /* Compact */5;
  }
}

export {
  setBookingDetailsInStorage ,
  readBookingDetailsFromStorage ,
  getBookingDetailsName ,
  getBookingDetailsMobile ,
  createBookingObject ,
  validateHouseAddress ,
  orderReviewLinkCreator ,
  validateAddressWithoutBounds ,
  getSpotServiceCategory ,
}
/* AuthConfig-PorterinFeature Not a pure module */
